import { DatetimeLevel } from './types.js';
export const getCorrectTimeLevel = (level, bucket) => {
    let newLevel = level ? level.toLocaleLowerCase() : DatetimeLevel.YEARS;
    if (newLevel === DatetimeLevel.MINUTES && bucket === '60') {
        newLevel = DatetimeLevel.HOURS;
    }
    return newLevel;
};
//# sourceMappingURL=date-time-filter-util.js.map